export const SkipTraceTableBorderStyles = [
  "border-border-action",
  "border",
  "border-solid",
  "overflow-auto",
  "relative",
  "shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]",
  "w-full",
  "h-full",
];

export const SkipTraceTableFixedHeaderStyles = [
  "sticky",
  "top-0",
  "bg-neutral-50",
  "py-4",
  "px-6",
  "font-semibold",
  "text-sm",
  "text-text-base-secondary",
  "border-border-action",
  "border-r",
  "border-b",
  "last:border-r-0",
];

export const SkipTraceTableRowStyles = [
  "border-x-0",
  "border-t-0",
  "border-b",
  "last:border-b-0",
  "border-solid",
  "border-border-action",
  "hover:bg-background-surface-neutral",
  "cursor-pointer",
];

export const SkipTraceTableColStyles = [
  "text-text-base-secondary",
  "font-normal",
  "text-sm",
  "leading-5",
  "whitespace-nowrap",
  "text-ellipsis",
  "overflow-hidden",
  "py-2",
  "px-6",
  "border-border-action",
  "border-r",
  "last:border-r-0",
];
